












































































































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine } from "@/utils/common";
import StandardFlag from "@/components/scope/standard-flag.vue";
import { Table, TableRowsSelect } from "@/utils/decorator";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import { splitThousands } from "@/utils/common";
import DataImport from "@/components/scope/data-import.vue";
const service = namespace("service-item");
@Component({
  components: { TableEnableFlag, StandardFlag, DataImport }
})
@Table("loadListData")
@Table.DataImport({
  templateUrl: "https://static.gtech.asia/static/template/speedbiz/服务项目导入.xlsx",
  actionUrl: "/filecloud/importServiceItems"
})
export default class Service extends Vue {
  @service.Action getServiceList;
  searchFrom = {
    supplierName: "",
    contact: "",
    contactMobile: ""
  };
  keyword: string = "";
  serviceList: any[] = [];
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  handleSearch() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  created() {
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getServiceList({
      status: "9",
      orderItems: this.mix_sortParams,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum,
      searchKey: this.keyword
    }).then(data => {
      this.serviceList = data.data.list;
      return data;
    });
  }
  handleEdit(row) {
    this.$router.push(`/setting/service-edit/${row.serviceCode}`);
  }
}
